import { useMutation } from 'react-query';
import { BID } from '../constants/queryDefinition';
import BidService from '../../services/BidService';

const bidService = BidService.get();

interface IUsePlaceBid {
  auctionId?: number;
  bidAmount?: number | string;
  dealerId?: string;
  isOmp: boolean;
  proxyAmount?: number | string;
  tradeId: number;
}

/**
 * Places a proxy on an upcoming auction
 */

const usePlaceProxy = ({
  auctionId,
  dealerId,
  isOmp,
  tradeId
}: IUsePlaceBid) => {
  const postProxy = async ({ bidAmount, proxyAmount }) => {
    let response;

    if (isOmp) {
      if (!dealerId) {
        throw new Error('Unexpected error occured');
      }

      response = await bidService.placeOmpUpcomingProxy(
        parseInt(dealerId, 10),
        tradeId,
        auctionId,
        bidAmount,
        proxyAmount
      );
    } else {
      response = await bidService.placeUpcomingProxy(
        tradeId,
        bidAmount,
        proxyAmount
      );
    }

    if (!response || response?.errorCode || response?.errorMessage)
      throw new Error(response?.errorMessage);

    return response;
  };

  const placeOrCreate = isOmp ? BID.KEY.PLACE : BID.KEY.CREATE;

  const proxyResponse = useMutation(postProxy, {
    mutationKey: `Proxy-${placeOrCreate}-${dealerId}-${auctionId}`
  });

  return proxyResponse;
};

export default usePlaceProxy;
